import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import * as moment from 'moment';
import { LumpSumPaymentInstruction } from '../../../../../../models/transactions/lump-sum-payment-instruction';

export enum VbPaymentChangeLumpSumCardVariant {
  Default = 'default',
  Current = 'current',
  New = 'new'
}

@Component({
  selector: 'app-vb-payment-change-lump-sum-card',
  templateUrl: './vb-payment-change-lump-sum-card.component.html',
  styleUrls: ['./vb-payment-change-lump-sum-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeLumpSumCardComponent implements OnChanges {
  @Input({ required: true }) lumpSumPaymentInstruction!: LumpSumPaymentInstruction | null;
  @Input({ required: true }) forgoRecurringPayments!: boolean;
  @Input() isBlank = false;
  @Input() variant: VbPaymentChangeLumpSumCardVariant = VbPaymentChangeLumpSumCardVariant.Default;

  public title = '';
  public formattedMonthYear = '';
  public amount = 0;

  public ngOnChanges(): void {
    if (!this.isBlank && this.lumpSumPaymentInstruction) {
      this.title = this.forgoRecurringPayments ? $localize`Lump Sum Payment*` : $localize`Lump Sum Payment`;
      this.amount = this.lumpSumPaymentInstruction.paymentAmount;

      if (this.lumpSumPaymentInstruction.desiredPaymentDate) {
        const date = moment(this.lumpSumPaymentInstruction.desiredPaymentDate.split('T')[0]);
        this.formattedMonthYear = date.format('MMMM, YYYY');
      }
    } else {
      this.title = $localize`Lump Sum Payment`;
      this.amount = 0;
    }
  }
}
